var y = (s) => {
  throw TypeError(s);
};
var u = (s, t, e) => t.has(s) || y("Cannot " + e);
var m = (s, t, e) => (u(s, t, "read from private field"), e ? e.call(s) : t.get(s)), E = (s, t, e) => t.has(s) ? y("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, e), p = (s, t, e, i) => (u(s, t, "write to private field"), i ? i.call(s, e) : t.set(s, e), e), l = (s, t, e) => (u(s, t, "access private method"), e);
const A = (s) => {
  const t = s.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  return t[t.length - 1];
}, b = class b extends HTMLElement {
  constructor() {
    super(), this.activeElement = void 0, this.menus = this.querySelectorAll("[menu]"), this.menuTriggers = this.querySelectorAll("[menu-trigger]"), this._handlePointerEnter = this._handlePointerEnter.bind(this), this._handlePointerOut = this._handlePointerOut.bind(this), this._handleMenuPointerEnter = this._handleMenuPointerEnter.bind(this), this._handleMenuPointerOut = this._handleMenuPointerOut.bind(this), this._handleButtonKeyDown = this._handleButtonKeyDown.bind(this), this._handleMenuCloseKeyDown = this._handleMenuCloseKeyDown.bind(this), this._handleMenuFocusOut = this._handleMenuFocusOut.bind(this), this._handleClick = this._handleClick.bind(this), this.startExitTimer = this.startExitTimer.bind(this), this.stopExitTimer = this.stopExitTimer.bind(this), this.activateMenuWithControl = this.activateMenuWithControl.bind(this);
  }
  get ctor() {
    return this.constructor;
  }
  connectedCallback() {
    Array.from(this.menuTriggers).forEach((t) => {
      t.addEventListener("pointerover", this._handlePointerEnter), t.addEventListener("pointerout", this._handlePointerOut), t.addEventListener("keydown", this._handleButtonKeyDown), t.hasAttribute("aria-controls") && t.addEventListener("click", this._handleClick);
    }), Array.from(this.menus).forEach((t) => {
      var e;
      t.addEventListener("pointerover", this._handleMenuPointerEnter), t.addEventListener("pointerout", this._handleMenuPointerOut), t.addEventListener("keydown", this._handleMenuCloseKeyDown), (e = A(t)) == null || e.addEventListener(
        "keydown",
        this._handleMenuFocusOut
      );
    });
  }
  _handleClick(t) {
    const e = t.currentTarget;
    t.preventDefault(), this.activeElement === e ? this.setActiveElement(void 0) : this._handleActivateButton(e);
  }
  _handleActivateButton(t) {
    t.getAttribute("aria-controls") || t.hasAttribute("data-controls") ? (this.stopExitTimer(), this.setActiveElement(t)) : this.setActiveElement(void 0);
  }
  _handleButtonKeyDown(t) {
    const e = t.currentTarget;
    if (t.key === "Enter" || t.key === " ")
      if (t.preventDefault(), this.activeElement === e)
        if (e.tagName.toLowerCase() === "a" && e.hasAttribute("href")) {
          const i = e.getAttribute("href");
          i && (window.location.href = i);
        } else
          e.click();
      else
        this._handleActivateButton(e);
    else t.key === "Escape" && (t.preventDefault(), this.setActiveElement(void 0), e.focus());
  }
  _handleMenuCloseKeyDown(t) {
    if (t.key === "Escape") {
      t.preventDefault(), this.setActiveElement(void 0);
      const e = Array.from(this.menuTriggers).find(
        (i) => i.getAttribute("aria-expanded") === "true"
      );
      e == null || e.focus();
    }
  }
  _handleMenuFocusOut(t) {
    t.key === "Tab" && !t.shiftKey && this.startExitTimer();
  }
  _handlePointerEnter(t) {
    const e = t.currentTarget;
    this._handleActivateButton(e);
  }
  _handlePointerOut(t) {
    const e = t.currentTarget;
    this.activeElement === e && this.startExitTimer();
  }
  _handleMenuPointerEnter() {
    this.stopExitTimer();
  }
  _handleMenuPointerOut() {
    this.startExitTimer();
  }
  startExitTimer() {
    this.exitTimer = window.setTimeout(() => {
      this.setActiveElement(void 0);
    }, this.ctor.EXIT_TIMEOUT);
  }
  stopExitTimer() {
    this.exitTimer && window.clearTimeout(this.exitTimer);
  }
  setActiveElement(t) {
    if (this.activeElement !== t)
      if (this.activeElement = t, this.activateMenuWithControl(this.activeElement), this._handleMenuDrawerARIATags(), this.dataset.state = this.activeElement ? "active" : "inactive", this.activeElement) {
        const e = this.activeElement.getAttribute("aria-controls") || this.activeElement.getAttribute("data-controls"), i = this.querySelector(`#${e}`);
        if (i) {
          const n = i.getBoundingClientRect().height;
          this.style.setProperty("--mega-menu-height", `${n}px`);
        } else
          this.style.setProperty("--mega-menu-height", "10px");
      } else
        this.style.setProperty("--mega-menu-height", "0px");
  }
  activateMenuWithControl(t) {
    for (const e of Array.from(this.menuTriggers)) {
      const i = e.getAttribute("aria-controls"), n = e.getAttribute("data-controls");
      (i || n) && e === t ? e.setAttribute("aria-expanded", "true") : e.setAttribute("aria-expanded", "false");
    }
  }
  _handleMenuDrawerARIATags() {
    for (const t of Array.from(this.menus)) {
      if (!this.activeElement) {
        t.setAttribute("aria-hidden", "true");
        continue;
      }
      const e = this.activeElement.getAttribute("aria-controls") || this.activeElement.getAttribute("data-controls");
      t.id === e ? t.setAttribute("aria-hidden", "false") : t.setAttribute("aria-hidden", "true");
    }
  }
};
b.EXIT_TIMEOUT = 100;
let f = b;
window.customElements.get("mega-menu") || window.customElements.define("mega-menu", f);
var a, h, c;
const v = class v extends HTMLElement {
  constructor() {
    super();
    E(this, h);
    E(this, a);
    this.lastScrollY = window.scrollY, this.lastPageHeight = document.documentElement.scrollHeight, p(this, a, new ResizeObserver(() => l(this, h, c).call(this))), this.hasStickyEnabled = !0, this.hasStickyEnabled = this.getAttribute("is-sticky") === "true";
  }
  connectedCallback() {
    l(this, h, c).call(this), m(this, a).observe(this), this.setUpFoldObserver(), this.hasStickyEnabled && (this.timeInterval = setInterval(() => {
      this.setNewScrollValue(window.scrollY);
    }, 150));
  }
  setUpFoldObserver() {
    const e = {
      root: null,
      threshold: 0.1
    }, i = new IntersectionObserver((n) => {
      n.forEach((o) => {
        o.isIntersecting || (document.body.setAttribute("data-below-fold", "true"), this.dispatchEvent(
          new CustomEvent("header:below-fold", {
            bubbles: !0
          })
        ), i.disconnect());
      });
    }, e);
    i.observe(this);
  }
  get scrollDirection() {
    return parseInt(this.getAttribute("data-scroll-direction") || "0", 10);
  }
  attributeChangedCallback(e, i) {
    e === "data-scroll-direction" && (parseInt(i, 10) === 0 && this.scrollDirection === 1 ? this.classList.add("opacity-0") : this.classList.remove("opacity-0"), l(this, h, c).call(this));
  }
  get isSticky() {
    return this.scrollDirection === -1 && this.hasStickyEnabled;
  }
  disconnectedCallback() {
    m(this, a).disconnect();
  }
  setScrollDirection(e) {
    this.setAttribute("data-scroll-direction", e.toString());
  }
  setNewScrollValue(e) {
    if (this.lastPageHeight !== document.documentElement.scrollHeight) {
      this.lastScrollY = e, this.lastPageHeight = document.documentElement.scrollHeight;
      return;
    }
    const i = this.clientHeight + 600, n = this.clientHeight + 800;
    if (this.scrollDirection === 0 && e <= n) {
      this.lastScrollY = e;
      return;
    }
    if (this.scrollDirection === -1 && e <= i) {
      this.setScrollDirection(1), setTimeout(() => {
        this.setScrollDirection(0);
      }, 250), this.lastScrollY = e;
      return;
    }
    if (e <= i) {
      this.setScrollDirection(0), this.lastScrollY = e;
      return;
    }
    Math.abs(e - this.lastScrollY) < 5 || (e >= this.lastScrollY ? this.setScrollDirection(1) : this.setScrollDirection(-1), this.lastScrollY = e);
  }
};
a = new WeakMap(), h = new WeakSet(), c = function() {
  const e = this.clientHeight, i = this.querySelector(
    ".shopify-section-main-header .header-internal-wrapper"
  ), n = this.querySelector(
    "[data-header-col-1]"
  );
  if (document.documentElement.style.setProperty(
    "--header-height-actual",
    `${e}px`
  ), this.isSticky ? i && document.documentElement.style.setProperty(
    "--header-height",
    `${i.clientHeight}px`
  ) : document.documentElement.style.setProperty("--header-height", "0px"), n) {
    const o = n.querySelectorAll("div[data-logo]");
    n.clientWidth > 271 ? o.forEach((r, d) => {
      d < 2 ? r.classList.remove("hidden") : r.classList.add("hidden");
    }) : n.clientWidth > 149 ? o.forEach((r, d) => {
      d < 1 ? r.classList.remove("hidden") : r.classList.add("hidden");
    }) : o.forEach((r) => {
      r.classList.add("hidden");
    });
  }
}, v.observedAttributes = ["data-scroll-direction", "is-sticky"];
let g = v;
window.customElements.define("main-header", g);
export {
  g as MainHeader
};
